import previewPicture from './previewPicture.vue'
export default previewPicture
